module.exports = "<finders-header></finders-header>\n\n<router-outlet (activate)=\"onActivate()\"></router-outlet>\n\n<finders-footer></finders-footer>\n"